<template>
  <div>
    <div class="row">
      <div class="col-lg-6 px-4">
        <!-- <label v-if="user.date1" style="margin-top: 0;">Date of Birth</label>
        <p v-if="user.date1">{{ new Date(user.date1).toDateString() }} (Age: {{ getAge(new Date(user.date1).toDateString()) }})</p> -->
        <label style="margin-top: 0;">Years of Experience</label>
        <p>{{ user.selector1 }}</p>
        <label style="">Position(s) Applying For</label>
        <ul class="">
          <li v-for="(sector, index) in user.sectors" :key="'sector'+index">{{ sector }}</li>
        </ul>
        <label>Commitment</label>
        <p>{{ user.selector2 }}</p>
        <p>{{ user.text2 }}</p>
        <label style="">Availability</label>
        <ul class="">
          <li v-for="(preference, index) in user.preferences" :key="'preference'+index">{{ preference }}</li>
        </ul>
        <label>Ideal Schedule</label>
        <p>{{ user.text3 }}</p>
        <label>Languages</label>
        <p>{{ user.text4 }}</p>
        <label>Why did last postion end</label>
        <p>{{ user.text5 }}</p>
        <div v-if="editAccess">
          <label>Pay Range</label>
          <p>{{ user.text6 }}</p>
        </div>
        <label>Start Date</label>
        <p>{{ new Date(user.available_date).toDateString() }}</p>
      </div>

      <div class="col-lg-6 px-4">
        <label style="margin-top: 0;">Driver's License and Car?</label>
        <p>{{ user.selector3 }}</p>
        <label>CPR and First Aid certified?</label>
        <p>{{ user.selector4 }}</p>
        <label>Up to date on vaccinations?</label>
        <p>{{ user.selector5 }}</p>
        <label style="">Ok with pets?</label>
        <ul class="">
          <li v-for="(preference2, index) in user.preferences2" :key="'preference2'+index">{{ preference2 }}</li>
        </ul>
        <label style="">Ok with travel?</label>
        <ul class="">
          <li v-for="(preference3, index) in user.preferences3" :key="'preference3'+index">{{ preference3 }}</li>
        </ul>
        <label>Legally able to work in the United States?</label>
        <p>{{ user.selector6 }}</p>
        <label>Comfortable being paid legally?</label>
        <p>{{ user.selector7 }}</p>
        <div v-if="editAccess">
          <label style="">Valid Social Security Number?</label>
          <p>{{ user.text7 }}</p>
        </div>
        <label style="">Experience</label>
        <pre>{{ user.text8 }}</pre>
      </div>
    </div>

    <!-- <div v-if="user.preferences[0] || user.text10" class="row">
      <div class="col-lg-6 px-4">
        <h4 style="margin-bottom: -5px;">Logistics</h4>
        <div v-if="editAccess">
          <label v-if="user.preferences[0]">Position(s) Applying For</label>
          <ul class="">
            <li v-for="(preference, index) in user.preferences" :key="'Preference'+index">{{ preference }}</li>
          </ul>
          <label v-if="user.preferences3[0]">How I'd like to be Notified of New Opportunities</label>
          <ul class="">
            <li v-for="(preference, index) in user.preferences3" :key="'Preference3'+index">{{ preference }}</li>
          </ul>
        </div>

        <div>
          <label v-if="user.boolean_selector1">I have a valid driver's license.</label>
          <label v-if="!user.boolean_selector1">I do not have a valid driver's license.</label>
        </div>
        <label v-if="user.text2">Year, Make & Model of Vehicle</label>
        <p>{{ user.text2 }}</p>
        <div>
          <label v-if="user.boolean_selector2">I have had an accident or driving violation.</label>
          <label v-if="!user.boolean_selector2">I have not had any accidents or driving violations.</label>
        </div>
        <p>{{ user.text3 }}</p>
        <hr style="">
        <h4 style="margin-bottom: -5px;">Education</h4>
        <div v-if="editAccess">
          <label v-if="user.text10">High School</label>
          <p>{{ user.text10 }}</p>
        </div>

        <div>
          <label v-if="user.boolean_selector4">I graduated high school.</label>
          <label v-if="!user.boolean_selector4">I did not graduate high school.</label>
        </div>
        <div>
          <label v-if="user.boolean_selector5">I am attending a post-secondary school.</label>
          <label v-if="!user.boolean_selector5">I am not attending a post-secondary school.</label>
        </div>
        <p>{{ user.text11 }}</p>
      </div>
      <div class="col-lg-6 px-4">
        <h4>Childcare Experience</h4>
        <label v-if="user.skills[0]" style="margin-top: 0;">Ages I have experience with</label>
        <ul>
          <li v-for="(skill, index) in user.skills" :key="'Skill'+index">{{ skill }}</li>
        </ul>
        <label v-if="user.skills2[0]">Types of experience I have</label>
        <ul>
          <li v-for="(skill2, index) in user.skills2" :key="'Skill2'+index">{{ skill2 }}</li>
        </ul>
        <p v-if="user.text5">Other: {{ user.text5 }}</p>
        <label v-if="user.skills3[0]">I am comfortable with</label>
        <ul>
          <li v-for="(skill3, index) in user.skills3" :key="'Skill3'+index">{{ skill3 }}</li>
        </ul>
        <label v-if="user.text4">Languages I speak fluently</label>
        <p>{{ user.text4 }}</p>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  props: ['user'],
  computed: {
    editAccess() {
      if (this.user.id == this.$store.getters.userID || this.$store.getters.isAgent === true) {
        return true
      } else {
        return false
      }
    },
    viewOnlyAccess() {
      if (this.$store.getters.isEmployer === true) {
        return true
      } else {
        return false
      }
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/candidates/profile/ProfessionalInfo.vue